import React, { Component } from 'react';

//generic functions
import {
    fetchCariOutageMessages
} from "../../../../../functions/generic_functions";

//views
import CariMainPgHeaderView from "../../cari_template_view/CariMainPgHeaderView";
import CariReferencePg from "../../cari_reference_view/CariReferencePg";
import CariReferenceSubmittedPg from "../../cari_reference_view/CariReferenceSubmittedPg";
import CariLoginPageLayoutRouting from "./CariLoginPageLayoutRouting";

//router
import {
    Route, 
    Switch,
    Redirect
} from 'react-router-dom';

//get static routes
import {
    cari_reference_submitted_url,
    cari_reference_url,
    cari_home_pg_url,
    cari_api_load_outage_banner_url,
} from "../../../../../router/static_routes";

/*

    props {
        siteTitle: site title
    }
*/
class CariMainPg extends Component {

    state = {
        beedieTracs: "Beedie TRACS",
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (  
            <div>
                <div id='container'>
                    <div id='page'>
                        <div>
                            <CariMainPgHeaderView 
                                siteTitle={this.props.siteTitle} 
                            />
                        </div>    

                        <div 
                            id='page-content' 
                            className='no-navigation'
                        >
                            <section className='main'>
                                <div className="p-grid">
                                    <div className="p-col-12">
                                        <Switch>
                                            <Route
                                                exact
                                                path={cari_reference_url + "/:referenceCode([a-zA-Z0-9-+.$_]{10,})"}
                                                component={CariReferencePg}
                                            />

                                            <Route
                                                exact
                                                path={cari_reference_submitted_url}
                                                component={CariReferenceSubmittedPg}
                                            />

                                            <Route
                                                path={cari_home_pg_url}
                                                component={CariLoginPageLayoutRouting}
                                            />

                                            <Redirect
                                                from='*'
                                                to={cari_home_pg_url}
                                            />
                                        </Switch>
                                    </div>
                                </div>
                            </section>
                        </div>
                    
                        {/* load footer */}
                        <div>
                            <footer className="footer_style">
                                <div>
                                    {this.state.beedieTracs} | 
                                    <a
                                        href='http://www.sfu.ca/webmaster/terms.html' target='_blank'
                                        rel="noopener noreferrer"
                                    > Terms &amp; Privacy 
                                    </a> | © Simon Fraser University
                                </div>
                            </footer>
                        </div>
                   
                    </div>
                </div>
            </div>
        );
    }
}
export default CariMainPg;